import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'

import { Container, Row, Col, Nav } from "react-bootstrap";
import Slider from "react-slick";

function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
        <button type="button" className={`slick-next ${className}`} style={{ ...style }} onClick={onClick} ><i className="far fa-angle-right"></i></button>
    );
}

function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
        <button type="button" className={`slick-prev ${className}`} style={{ ...style }} onClick={onClick} ><i className="far fa-angle-left"></i></button>
    );
}



const departments = [
  "All Departments",
  "SOET",
  "LAW",
  "SOPS",
  "SASH",
  "SBMC",
  "SOSAH",
  "SOA",
];

const alumniData = [
  {
    id: 1,
    department: "SOET",
    name: "GhanShyam",
    image: "https://picsum.photos/70?1",
    course: "Mechanical Engineering (2017)",
    designation: "Junior Engineer",
    company: "Company",
    package: "6 LPA",
    quote:
      "My journey in the Mechanical Engineering department laid a strong foundation for my professional career.",
  },
  {
    id: 2,
    department: "SOET",
    name: "Nikhil Garg",
    image: "https://picsum.photos/70?2",
    course: "Civil Engineering (2017)",
    designation: "Senior Structure Engineer",
    company: "Company",
    package: "7.4 LPA",
    quote:
      "The department emphasized core engineering concepts along with real-world applications.",
  },
  {
    id: 3,
    department: "SOET",
    name: "Abhishek Goel",
    image: "https://picsum.photos/70?3",
    course: "Computer Science (2017)",
    designation: "Data Scientist",
    company: "Company",
    package: "8 LPA",
    quote:
      "The Computer Science department played a vital role in shaping my technical mindset.",
  },
];



 const settings = {
        //     dots: true,
        //   infinite: true,
        //   speed: 500,
        //   slidesToShow: 1,
        //   slidesToScroll: 1
        autoplay: true,
        autoplaySpeed: 4000,
        dots: false,
        fade: true,
        arrows: true,
        prevArrow: <SamplePrevArrow />,
        nextArrow: <SampleNextArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: true,
                    arrows: true,
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
const sliderImg=[
    
    {img:'/assets/homepage/allumani_banner01.jpg'},
    {img:'/assets/homepage/allumani_banner03.jpg'},
    {img:'/assets/homepage/allumani_banner02.jpg'},
     {img:'/assets/homepage/allumani_banner04.jpg'},
     
    

]



function Alumni() {

    const [activeTab, setActiveTab] = useState("All Departments");

  const filteredData =
    activeTab === "All Departments"
      ? alumniData
      : alumniData.filter((item) => item.department === activeTab);



    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Alumni" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">     
                        
                        <section class="alumni-content">
    <p>
        MVN University takes pride in the achievements of its alumni, who, after completing their studies, have excelled in diverse fields such as entrepreneurship, industry, academia, research, social service, and public administration. Many of them have earned national and international recognition, contributing to the university’s reputation worldwide. With a network of over 4,000 alumni across the globe, they have played a vital role in enhancing the image of MVN University, Palwal.
    </p>

    <p>
        Despite pursuing different paths, alumni remain deeply connected to their alma mater, consistently supporting it through generous contributions. This spirit of giving back is evident in initiatives like infrastructure development, scholarships for girl students, funding hobby clubs, establishing R&amp;D labs and faculty chairs, and donations toward community development and environmental projects.
    </p>

    <p>
        Founded in 2012, the Alumni Association of MVN University is an independent registered body representing this global network. Its mission includes:
    </p>

    <ul>
        <li>
            <strong>Promoting interaction</strong> and networking among alumni.
        </li>
        <li>
            <strong>Providing support</strong> during times of need.
        </li>
        <li>
            <strong>Encouraging giving back</strong> to the university.
        </li>
        <li>
            <strong>Operating on a charitable basis</strong> with a no profit-no loss principle.
        </li>
        <li>
            <strong>Strengthening MVN University’s image</strong> nationally and internationally.
        </li>
    </ul>
   <br/>
    <p>
        Alumni chapters established worldwide actively foster networking and maintain strong ties with the university. Organizing <strong>reunions</strong> has become a cornerstone of the association’s activities, reinforcing the bond between alumni and their alma mater.
    </p>
</section>


<section> 
        <Slider className="slider-active" style={{ background: "#141b22" }} {...settings}>
                    {sliderImg.map((item)=>(
                        <div>
                        <img src={item.img} className='slider-height' />
                    </div>
                    ))}
                    
                </Slider> 
</section>

 <section className="py-5 detapartment_tabs05"> 

        <h2 className="text-center fw-bold mb-4">Departments</h2>

        <Nav
          variant="pills"
          className="justify-content-center flex-wrap gap-2 mb-5"
        >
          {departments.map((department) => (
            <Nav.Item key={department}>
              <Nav.Link
                eventKey={department}
                active={activeTab === department}
                onClick={() => setActiveTab(department)}
              >
                {department}
              </Nav.Link>
            </Nav.Item>
          ))}
        </Nav>

        <Row className="g-4">

          {filteredData.length > 0 ? (
            filteredData.map((item) => (
              <Col lg={4} md={6} key={item.id}>
                <div className="alumni-card">

                  <div className="d-flex align-items-center mb-3">

                    <img
                      src={item.image}
                      alt={item.name}
                      className="rounded-circle border border-primary me-3"
                      width="60"
                      height="60"
                    />

                    <div>
                      <h5 className="fw-bold mb-1">{item.name}</h5>
                      <small>{item.course}</small>
                    </div>

                  </div>

                  <hr />

                  <p>
                    <strong>Designation:</strong> {item.designation}
                  </p>

                  <p>
                    <strong>Company/Business:</strong> {item.company}
                  </p>

                  <p>
                    <strong>Current Package:</strong>{" "}
                    <span className="badge bg-danger">
                      {item.package}
                    </span>
                  </p>

                  <div className="quote-box">
                    <em>"{item.quote}"</em>
                  </div>

                </div>
              </Col>
            ))
          ) : (
            <Col>
              <div className="text-center py-5">
                <h5>No Alumni Found</h5>
              </div>
            </Col>
          )}

        </Row>
 
    </section>





                    </div>    
                    
                </div>
            </section>
        </>
    )
}

export default Alumni